/* eslint-disable no-undef */
import {menuVideos, signUpPageView, trackOpen} from '../../../segment'
import {version} from '../../../../package.json'
;(function module() {
  angular
    .module('app.lexstepHeader', [])
    .directive('lexstepHeader', function directive() {
      return {
        // eslint-disable-next-line angular/directive-restrict
        restrict: 'AE',
        replace: true,
        template: require('./header.html'),
        controller: headerCtrl,
      }
    })
  function headerCtrl(
    $rootScope,
    $scope,
    $location,
    userService,
    accountPermission,
    headerApi,
    logger,
    $window,
    api
  ) {
    $window.addEventListener('storage', function syncLogout(event) {
      if (event.key === 'logout') {
        $window.localStorage.setItem('logout', Date.now())
        $window.localStorage.removeItem('token')
        $window.localStorage.removeItem('user')
        $window.location.href = '/signin'
      }

      if (event.key === 'signIn') {
        const user = JSON.parse($window.localStorage.getItem('user'))
        if (user) $location.path(user.defaultRoute)
        $scope.$apply()
      }

      if (event.key === 'tokenInMemoryUpdated') {
        const token = $window.localStorage.getItem('token')
        if (token) {
          api.updateInMemoryToken(JSON.parse(token))
        }
      }
    })

    $scope.applicationInfo = {
      version,
    }

    $scope.serverInfo = {
      version: '',
    }

    const getServerVersion = async () => {
      const result = await api.get('health/info')
      $scope.serverInfo = result
      return result
    }

    const setServerInfo = () => {
      getServerVersion().then(({data}) => {
        $scope.serverInfo = data
        $scope.$applyAsync()
      })
    }

    setServerInfo()

    $rootScope.$on('$routeChangeStart', function on(_event, _current) {
      setServerInfo()
    })

    $scope.path = $location.url()
    // eslint-disable-next-line unicorn/consistent-function-scoping
    const notifyControllersThatTheUserIsLoaded = (rootScope, user) => {
      rootScope.$broadcast('user-load', user)
    }

    function updateUserModel(result) {
      $rootScope.user = result
      setUserProfilePic($rootScope.user)
      notifyControllersThatTheUserIsLoaded($rootScope, $rootScope.user)
      $scope.$apply()
      if (result) {
        showMeMoveAlert()
      }
    }

    const resetUserModel = () => {
      userService.setUser().then(updateUserModel)
    }

    const hideMeMoveNotification = (
      hideAlert = $rootScope.hideMeMoveAlert,
      hidePopup = $rootScope.hideMeMoveAlertPopup
    ) => {
      headerApi
        .updateMeMoveAlert({
          userId: $rootScope.user.user_ID,
          isAlertSeen: hideAlert,
          isPopupSeen: hidePopup,
        })
        .then(() => {
          $scope.meMoveAlert = 'zoomOutRight'
          $rootScope.hideMeMoveAlert = hideAlert
          $rootScope.user.lawyer.meMoveAlert = hideAlert
          $rootScope.hideMeMoveAlertPopup = hidePopup
          $rootScope.user.lawyer.meMoveAlertPopup = hidePopup

          if (hidePopup) {
            toastr.clear()
          }
        })
    }

    const updateMeMoveAlertPopup = () => {
      hideMeMoveNotification(undefined, true)
    }

    const showMeMoveAlert = () => {
      if ($rootScope.user && $rootScope.user.lawyer) {
        let profileUrl = '/user-profile'
        let currentUrl = $location.url()
        $rootScope.hideMeMoveAlert = $rootScope.user.lawyer.meMoveAlert
        $rootScope.hideMeMoveAlertPopup =
          $rootScope.user.lawyer.meMoveAlertPopup

        if (!$rootScope.hideMeMoveAlert && currentUrl === profileUrl) {
          hideMeMoveNotification(true, true)
        }

        if (
          !$rootScope.hideMeMoveAlertPopup &&
          !$rootScope.isVisibleMeMoveAlert
        ) {
          logger.notify(
            'warning',
            "<span class='meMoveAlertPopupText'> Select 'My Profile' under your name above to edit your LexStep Profile and Preferences.</span>",
            {
              onHidden: updateMeMoveAlertPopup,
              onShown: customizeMeMovePopup,
              timeOut: 0,
              extendedTimeOut: 0,
              preventDuplicates: true,
            }
          )
          $rootScope.isVisibleMeMoveAlert = true
        }
      }
    }

    const initializeSettings = () => {
      showMeMoveAlert()
      $rootScope.isSpecOppsUrl = $location.path() === '/opportunities'
    }

    $scope.showClass = ''
    userService.verifySession().then(updateUserModel)

    $scope.hideAllNotifications = () => {
      updateMeMoveAlertPopup()
    }

    $scope.hideDropDown = type => {
      $scope.showClass = ''
      if (type === 'videos') {
        menuVideos()
      } else if (type === 'sign-up') {
        signUpPageView()
      }
    }

    $scope.trackPageRedirection = () => {
      trackOpen()
    }

    $scope.isEmailListingAllowed = () => {
      return accountPermission.isEmailListingAllowed($rootScope.user)
    }

    $scope.isLawyerListingAllowed = () => {
      return accountPermission.isLawyerListingAllowed($rootScope.user)
    }

    $scope.openClassOnList = id => {
      // eslint-disable-next-line angular/document-service
      var element = angular.element(document.querySelector(String(String(id))))
      element.addClass('open')
    }

    $scope.logOut = () => {
      toastr.remove()
      $rootScope.user = {}
      api.endSession()
    }

    $scope.showDropDown = () => {
      if ($scope.showClass === '') {
        $scope.showClass = 'show'
      } else {
        $scope.showClass = ''
      }
    }

    $scope.onClickNavItem = title => {
      const user = $rootScope.user
      const eventLabel = `User(${user.user_ID}): ${user.first_Name}`

      // eslint-disable-next-line angular/window-service
      window.ga('send', 'event', {
        eventCategory: title,
        eventAction: 'expand',
        eventLabel,
      })
    }

    $rootScope.$on('user-update', resetUserModel)
    $rootScope.$on('$routeChangeStart', initializeSettings)
  }
})()

const setUserProfilePic = user => {
  if (user) {
    if (user.profilePicture && user.profilePicture.contains('https'))
      user.profilePicSrc = user.profilePicture
    else
      user.profilePicSrc = user.profilePicture
        ? `${process.env.PUBLIC_BUCKET_URL}/user/${user.id}/photo/${user.profilePicture}`
        : 'images/defaultPic.jpg'
  }
}

const customizeMeMovePopup = () => {
  let meMoveAlertPopup = $('.meMoveAlertPopupText')
  meMoveAlertPopup.parents('.toast').css({opacity: '1'})
  meMoveAlertPopup.parents('#toast-container').css({
    // eslint-disable-next-line angular/window-service
    top: window.innerWidth > 1024 ? '140px' : '64px',
  })
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/header/header.js